var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1795 2.3999H3.81649C3.03495 2.3999 2.3999 3.02002 2.3999 3.78449V20.2154C2.3999 20.9799 3.03495 21.6007 3.81649 21.6007H20.1795C20.9628 21.6007 21.6 20.9799 21.6 20.2154V3.78449C21.6 3.02002 20.9628 2.3999 20.1795 2.3999Z",
    fill: "#F0F0F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97585 4.99487C7.86988 4.99487 8.59634 5.72133 8.59634 6.61676C8.59634 7.51113 7.86988 8.23759 6.97585 8.23759C6.08008 8.23759 5.35571 7.51113 5.35571 6.61676C5.35571 5.72133 6.08008 4.99487 6.97585 4.99487ZM5.57808 18.4629H8.37466V9.46675H5.57808V18.4629Z",
    fill: "#36384C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1279 9.46672H12.8097V10.6969H12.8481C13.2212 9.98931 14.1334 9.24365 15.4935 9.24365C18.3246 9.24365 18.8472 11.1064 18.8472 13.5288V18.4628H16.0524V14.0877C16.0524 13.0442 16.0346 11.7023 14.5995 11.7023C13.1444 11.7023 12.9228 12.8397 12.9228 14.013V18.4628H10.1279V9.46672Z",
    fill: "#36384C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInDark);
export default __webpack_public_path__ + "static/media/LinkedInDark.a649b448bae8d6df3015cecf3a0cad4d.svg";
export { ForwardRef as ReactComponent };